// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file issues/v1/milestone_show.proto (package github.issues.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file issues/v1/milestone_show.proto.
 */
export const file_issues_v1_milestone_show: GenFile = /*@__PURE__*/
  fileDesc("Ch5pc3N1ZXMvdjEvbWlsZXN0b25lX3Nob3cucHJvdG8SEGdpdGh1Yi5pc3N1ZXMudjEiVgoVTWlsZXN0b25lU2hvd1Jlc3BvbnNlEj0KCnJlcG9zaXRvcnkYASABKAsyKS5naXRodWIuaXNzdWVzLnYxLk1pbGVzdG9uZVNob3dSZXBvc2l0b3J5Ir0CChdNaWxlc3RvbmVTaG93UmVwb3NpdG9yeRIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEhcKD25hbWVfd2l0aF9vd25lchgDIAEoCRITCgtpc19hcmNoaXZlZBgEIAEoCBITCgtpc19kaXNhYmxlZBgFIAEoCBIaChJpc19pbl9vcmdhbml6YXRpb24YBiABKAgSEQoJaXNfbG9ja2VkGAcgASgIEiQKHHZpZXdlcl9jYW5fdXBkYXRlX21pbGVzdG9uZXMYCCABKAgSMwoFb3duZXIYCSABKAsyJC5naXRodWIuaXNzdWVzLnYxLk1pbGVzdG9uZVNob3dPd25lchI7CgltaWxlc3RvbmUYCiABKAsyKC5naXRodWIuaXNzdWVzLnYxLk1pbGVzdG9uZVNob3dNaWxlc3RvbmUibQoSTWlsZXN0b25lU2hvd093bmVyEgoKAmlkGAEgASgJEg0KBWxvZ2luGAIgASgJEjwKCm93bmVyX3R5cGUYAyABKA4yKC5naXRodWIuaXNzdWVzLnYxLk1pbGVzdG9uZVNob3dPd25lclR5cGUimwMKFk1pbGVzdG9uZVNob3dNaWxlc3RvbmUSCgoCaWQYASABKAkSDgoGbnVtYmVyGAIgASgFEg0KBXRpdGxlGAMgASgJEg4KBmNsb3NlZBgEIAEoCBIaChJjbG9zZWRfaXNzdWVfY291bnQYBSABKAUSGAoQb3Blbl9pc3N1ZV9jb3VudBgGIAEoBRIxCgtkZXNjcmlwdGlvbhgHIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRI2ChBkZXNjcmlwdGlvbl9odG1sGAggASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEiwKBmR1ZV9vbhgJIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIbChNwcm9ncmVzc19wZXJjZW50YWdlGAogASgBEhIKCnVwZGF0ZWRfYXQYCyABKAkSRgoKcmVwb3NpdG9yeRgMIAEoCzIyLmdpdGh1Yi5pc3N1ZXMudjEuTWlsZXN0b25lU2hvd01pbGVzdG9uZVJlcG9zaXRvcnkiRwogTWlsZXN0b25lU2hvd01pbGVzdG9uZVJlcG9zaXRvcnkSCgoCaWQYASABKAkSFwoPbmFtZV93aXRoX293bmVyGAIgASgJKpMBChZNaWxlc3RvbmVTaG93T3duZXJUeXBlEikKJU1JTEVTVE9ORV9TSE9XX09XTkVSX1RZUEVfVU5TUEVDSUZJRUQQABIiCh5NSUxFU1RPTkVfU0hPV19PV05FUl9UWVBFX1VTRVIQARIqCiZNSUxFU1RPTkVfU0hPV19PV05FUl9UWVBFX09SR0FOSVpBVElPThACYgZwcm90bzM", [file_google_protobuf_wrappers]);

/**
 * @generated from message github.issues.v1.MilestoneShowResponse
 */
export type MilestoneShowResponse = Message<"github.issues.v1.MilestoneShowResponse"> & {
  /**
   * @generated from field: github.issues.v1.MilestoneShowRepository repository = 1;
   */
  repository?: MilestoneShowRepository;
};

/**
 * Describes the message github.issues.v1.MilestoneShowResponse.
 * Use `create(MilestoneShowResponseSchema)` to create a new message.
 */
export const MilestoneShowResponseSchema: GenMessage<MilestoneShowResponse> = /*@__PURE__*/
  messageDesc(file_issues_v1_milestone_show, 0);

/**
 * @generated from message github.issues.v1.MilestoneShowRepository
 */
export type MilestoneShowRepository = Message<"github.issues.v1.MilestoneShowRepository"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string name_with_owner = 3;
   */
  nameWithOwner: string;

  /**
   * @generated from field: bool is_archived = 4;
   */
  isArchived: boolean;

  /**
   * @generated from field: bool is_disabled = 5;
   */
  isDisabled: boolean;

  /**
   * @generated from field: bool is_in_organization = 6;
   */
  isInOrganization: boolean;

  /**
   * @generated from field: bool is_locked = 7;
   */
  isLocked: boolean;

  /**
   * @generated from field: bool viewer_can_update_milestones = 8;
   */
  viewerCanUpdateMilestones: boolean;

  /**
   * @generated from field: github.issues.v1.MilestoneShowOwner owner = 9;
   */
  owner?: MilestoneShowOwner;

  /**
   * @generated from field: github.issues.v1.MilestoneShowMilestone milestone = 10;
   */
  milestone?: MilestoneShowMilestone;
};

/**
 * Describes the message github.issues.v1.MilestoneShowRepository.
 * Use `create(MilestoneShowRepositorySchema)` to create a new message.
 */
export const MilestoneShowRepositorySchema: GenMessage<MilestoneShowRepository> = /*@__PURE__*/
  messageDesc(file_issues_v1_milestone_show, 1);

/**
 * @generated from message github.issues.v1.MilestoneShowOwner
 */
export type MilestoneShowOwner = Message<"github.issues.v1.MilestoneShowOwner"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string login = 2;
   */
  login: string;

  /**
   * @generated from field: github.issues.v1.MilestoneShowOwnerType owner_type = 3;
   */
  ownerType: MilestoneShowOwnerType;
};

/**
 * Describes the message github.issues.v1.MilestoneShowOwner.
 * Use `create(MilestoneShowOwnerSchema)` to create a new message.
 */
export const MilestoneShowOwnerSchema: GenMessage<MilestoneShowOwner> = /*@__PURE__*/
  messageDesc(file_issues_v1_milestone_show, 2);

/**
 * @generated from message github.issues.v1.MilestoneShowMilestone
 */
export type MilestoneShowMilestone = Message<"github.issues.v1.MilestoneShowMilestone"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 number = 2;
   */
  number: number;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: bool closed = 4;
   */
  closed: boolean;

  /**
   * @generated from field: int32 closed_issue_count = 5;
   */
  closedIssueCount: number;

  /**
   * @generated from field: int32 open_issue_count = 6;
   */
  openIssueCount: number;

  /**
   * @generated from field: google.protobuf.StringValue description = 7;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.StringValue description_html = 8;
   */
  descriptionHtml?: string;

  /**
   * @generated from field: google.protobuf.StringValue due_on = 9;
   */
  dueOn?: string;

  /**
   * @generated from field: double progress_percentage = 10;
   */
  progressPercentage: number;

  /**
   * @generated from field: string updated_at = 11;
   */
  updatedAt: string;

  /**
   * @generated from field: github.issues.v1.MilestoneShowMilestoneRepository repository = 12;
   */
  repository?: MilestoneShowMilestoneRepository;
};

/**
 * Describes the message github.issues.v1.MilestoneShowMilestone.
 * Use `create(MilestoneShowMilestoneSchema)` to create a new message.
 */
export const MilestoneShowMilestoneSchema: GenMessage<MilestoneShowMilestone> = /*@__PURE__*/
  messageDesc(file_issues_v1_milestone_show, 3);

/**
 * @generated from message github.issues.v1.MilestoneShowMilestoneRepository
 */
export type MilestoneShowMilestoneRepository = Message<"github.issues.v1.MilestoneShowMilestoneRepository"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name_with_owner = 2;
   */
  nameWithOwner: string;
};

/**
 * Describes the message github.issues.v1.MilestoneShowMilestoneRepository.
 * Use `create(MilestoneShowMilestoneRepositorySchema)` to create a new message.
 */
export const MilestoneShowMilestoneRepositorySchema: GenMessage<MilestoneShowMilestoneRepository> = /*@__PURE__*/
  messageDesc(file_issues_v1_milestone_show, 4);

/**
 * @generated from enum github.issues.v1.MilestoneShowOwnerType
 */
export enum MilestoneShowOwnerType {
  /**
   * @generated from enum value: MILESTONE_SHOW_OWNER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MILESTONE_SHOW_OWNER_TYPE_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: MILESTONE_SHOW_OWNER_TYPE_ORGANIZATION = 2;
   */
  ORGANIZATION = 2,
}

/**
 * Describes the enum github.issues.v1.MilestoneShowOwnerType.
 */
export const MilestoneShowOwnerTypeSchema: GenEnum<MilestoneShowOwnerType> = /*@__PURE__*/
  enumDesc(file_issues_v1_milestone_show, 0);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(MilestoneShowResponseSchema, "1a6ba519e903")
registerSchemaHash(MilestoneShowRepositorySchema, "a1c971a6552b")
registerSchemaHash(MilestoneShowOwnerSchema, "40e1dde32fc6")
registerSchemaHash(MilestoneShowMilestoneSchema, "d588454bcc6a")
registerSchemaHash(MilestoneShowMilestoneRepositorySchema, "f985f059c74e")
